import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId, PersonDocumentId } from '../../types/api/primaryKeys/PrimaryKey';
import { GetEmployeeDocumentsResponse } from '../../types/api/documentUploads/GetEmployeeDocumentsResponse';
import { AddEmployeePackageDocumentModel } from '../../types/api/documentUploads/AddEmployeePackageDocumentModel';


export async function getEmployeePackageDocuments(packageId: EnrollmentPackageId) {
    const result = await ApiRequest.get<readonly GetEmployeeDocumentsResponse[]>(`packages/${packageId}/employee-documents`);
    return result;
}

export async function addEmployeePackageDocument(packageId: EnrollmentPackageId, model: AddEmployeePackageDocumentModel) {
    await ApiRequest.post(`packages/${packageId}/employee-documents`, model);
}

export async function deleteEmployeePackageDocument(packageId: EnrollmentPackageId, personDocumentId: PersonDocumentId) {
    await ApiRequest.delete(`packages/${packageId}/employee-documents/${personDocumentId}`);
}